import { Modal } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import VenuesList from "../VenuesList";
import { getAddVenueToSeasonColumns } from "./columnsRepository";

const AddVenueToSeasonModal = ({ isOpen, setIsOpen, currentVenues, pageRef, reloadData }) => {
  const { organizationId } = useParams();
  const { seasonId } = useParams();
  const { sport } = useParams();
  const { formatMessage } = useIntl();

  return (
    <Modal
      open={isOpen}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={() => setIsOpen(false)}
      width={800}
      title={formatMessage({
        id: "venue.add",
        defaultMessage: "Add New Venue to Season",
      })}
      cancelText={formatMessage({
        id: "cancel",
        defaultMessage: "Cancel",
      })}
    >
      <VenuesList
        currentVenues={currentVenues}
        columns={getAddVenueToSeasonColumns({
          formatMessage,
          sport: sport,
          seasonId: seasonId,
          organizationId: organizationId,
          reloadData,
          pageRef,
        })}
      />
    </Modal>
  );
};

export default AddVenueToSeasonModal;
